import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalender5: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="calender-5,date"><path d="M20.25 8.25V20.25H3.75V8.25V3.75H7.75V5.29688" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 8.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 8.25V3.75H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 3.75H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.25 3.75V5.29688" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCalender5;
